import { render } from "./Home.vue?vue&type=template&id=8ee55316"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8ee55316&lang=scss"

import exportComponent from "D:\\development\\castorama\\bathroom-web2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__